export default {
    tooltip: 'tooltip',
    zoomIn:  'zoomIn',
    zoomOut: 'zoomOut',
};
